import { render } from "./DashboardTransmitters.vue?vue&type=template&id=2de37f18&scoped=true&ts=true"
import script from "./DashboardTransmitters.vue?vue&type=script&lang=ts"
export * from "./DashboardTransmitters.vue?vue&type=script&lang=ts"

import "./DashboardTransmitters.vue?vue&type=style&index=0&id=2de37f18&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de37f18"]])

export default __exports__